"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JarvisClientCredentialsAuthProvider = void 0;
const tslib_1 = require("tslib");
class JarvisClientCredentialsAuthProvider {
    constructor(clientId, clientSecret, tokenEndpoint, scopes) {
        this.accessToken = '';
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.endpoint = tokenEndpoint;
        this.scopes = scopes;
    }
    getAccessToken(forceRefresh) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //this.accessToken = this.accessToken || await // Make client_credentials grant type call to endpoint to get access token for scopes here
            return this.accessToken;
        });
    }
}
exports.JarvisClientCredentialsAuthProvider = JarvisClientCredentialsAuthProvider;
//# sourceMappingURL=jarvis-client-credentials-auth-provider.js.map